import api from '#config/api';

export const getAllAdelphiCaskFillings = () => api.get('/cask-fillings');

export const getAdelphiCaskFillingById = ({ id }) => api.get(`/cask-fillings/${id}`);

export const createAdelphiCasksOfExcel = values => api.post('/cask-fillings/excel', values);

export const deleteAdelphiCaskFillingById = ({ id }) => api.delete(`/cask-fillings/${id}`);
